import { useSearchParams } from 'react-router-dom';
import { PageHeader, cx } from '../components/ui';
import { ApiKeysSection } from './ApiKeysPage';
import { WebhooksSection } from './WebhooksPage';

// API / MCP — credentials + event webhooks for the REST API and MCP server in one place.
// Deep-linkable: /api-keys?tab=webhooks (used by the Integrations "Manage" action).
const TABS = [
  { key: 'keys', label: 'API Keys' },
  { key: 'webhooks', label: 'Webhooks' },
] as const;

export function ApiMcpPage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get('tab') === 'webhooks' ? 'webhooks' : 'keys';

  return (
    <div>
      <PageHeader
        title="API / MCP"
        subtitle="Keys and event webhooks for the REST API and MCP server. Secrets are shown once."
      />
      <div className="mb-6 flex gap-1 border-b border-line">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setParams(t.key === 'keys' ? {} : { tab: t.key }, { replace: true })}
            className={cx(
              '-mb-px border-b-2 px-4 py-2.5 text-sm font-medium transition-colors',
              tab === t.key
                ? 'border-ink text-ink'
                : 'border-transparent text-muted hover:text-ink',
            )}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'webhooks' ? <WebhooksSection /> : <ApiKeysSection />}
    </div>
  );
}
